
  import Vue from 'vue'
  import SpaceList from '@/components/admin/SpaceList.vue'

  export default Vue.extend({
    name: 'AdminSpaces',
    components: {
      SpaceList
    },
    created() {
      document.title = this.$vuetify.lang.t("$vuetify.tab_titles.admin_spaces")
    }
  })
